import React, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { RepairShops } from "./RepairShops";
import { RepairMaps } from "./RepairMaps";
import { Swiper, SwiperSlide } from "swiper/react";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ServiceTabs = (props) => {

  const [value, setValue] = useState(0);
  const [activeFilter, setActiveFilter] = useState(99);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className="SuitableCars vendorPage ">
      <Box sx={{ width: "100%", direction: "rtl" }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            margin: "0 2rem",
            fontSize: "14px",
            backgroundColor: "#FFFFFF",
            borderRadius: "8px",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="لیست" {...a11yProps(1)} />
            <Tab label="نقشه" {...a11yProps(0)} />
          </Tabs>
        </Box>
        <div className="filterCategories">
          <Swiper slidesPerView={2.5} spaceBetween={10}>
            <SwiperSlide>
              <span className="filterCategoryTitle">دسته بندی انتخابی :</span>
            </SwiperSlide>
            {props.categData.map((data, index) => (
              <SwiperSlide key={index}>
                <span
                  className={`filterCategoryItems ${
                    activeFilter == index ? "activeFilter" : ""
                  }`}
                  onClick={() => {
                    props.method.categhandler(data.id);
                    setActiveFilter(index);
                    props.method.setGaragesLoading(true);
                  }}
                >
                  {data.title}
                </span>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {/* <List>
              <div className="userCarC">
                <span className="UserCarTitleRe">دسته بندی ها</span>
              </div>

              <RadioGroup
                onClick={(e) => categhandler(e.target.value)}
                value={+category}
              >
                {categData.map((item, i) => (
                  <FormControlLabel
                    key={i}
                    value={item.id}
                    control={<Radio />}
                    label={`${item.title}`}
                  />
                ))}
              </RadioGroup>
            </List> */}
        <TabPanel value={value} index={0}>
          <RepairShops data={props.data} loading={props.loading} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <RepairMaps
            data={props.data}
            userLocation={props.userLocation}
            mapLoading={props.mapLoading}
            addressHandler={props.method.addressHandler}
            setMapLoading={props.method.setMapLoading}
          />
        </TabPanel>
      </Box>
    </div>
  );
};

export default ServiceTabs;
